module.exports = "/assets/d9fe06d775dd329e398a9bd8449c24a3.png";